import * as Reach from '@reach/menu-button';

import { CODE_SAMPLES_URL, PRODUCT_DOCS_URL } from '#/routes-external';

import ChevronDownIcon from '#/assets/ChevronDownIcon';
import ProductDocsIcon from '#/assets/ProductDocsIcon';
import ApiDocsIcon from '#/assets/ApiDocsIcon';
import CodeSamplesIcon from '#/assets/CodeSamplesIcon';

import { useTranslation } from '#/features/localization/utils';

import { NavItemPopoverButtonWithArrow, PopoverMenu } from './PopoverMenu';

export default function DevelopersMenu() {
  const { t } = useTranslation();

  return (
    <Reach.Menu>
      <Reach.MenuButton as={NavItemPopoverButtonWithArrow}>
        {t('Developers')} <ChevronDownIcon strokeWidth={2} />
      </Reach.MenuButton>
      <Reach.MenuList as={PopoverMenu}>
        <Reach.MenuLink target="_blank" rel="noopener" href={PRODUCT_DOCS_URL}>
          <ProductDocsIcon /> {t('Docs')}
        </Reach.MenuLink>
        <Reach.MenuLink target="_blank" rel="noopener" href={API_DOCS_URL}>
          <ApiDocsIcon /> {t('API Docs')}
        </Reach.MenuLink>
        <Reach.MenuLink target="_blank" rel="noopener" href={CODE_SAMPLES_URL}>
          <CodeSamplesIcon /> {t('Code Samples')}
        </Reach.MenuLink>
      </Reach.MenuList>
    </Reach.Menu>
  );
}
